import React from "react";
import "../styles/privacy-policy.css";

export default function PrivacyPolicy() {
  return (
    <div className="privacy-policy-page">
      <section className="privacy-header">
        <h1>Politika privatnosti</h1>
      </section>

      <section className="privacy-content">
        <div className="privacy-wrapper">
          <p className="privacy-intro">
            Ova Politika privatnosti objašnjava kako prikupljamo, koristimo i štitimo osobne podatke korisnika koji posjećuju i koriste ovu web stranicu.
          </p>

          <h2>1. Prikupljanje osobnih podataka</h2>
          <p>
            Osobni podaci koje možemo prikupljati uključuju ime i prezime, e-mail adresu, telefonski broj te druge podatke koje korisnik dobrovoljno unese putem kontakt obrasca ili druge komunikacije.
          </p>

          <h2>2. Način korištenja podataka</h2>
          <p>Prikupljene podatke koristimo isključivo u svrhu:</p>
          <ul>
            <li>odgovaranja na upite korisnika</li>
            <li>pružanja traženih informacija ili usluga</li>
            <li>poboljšanja funkcionalnosti i sadržaja web stranice</li>
          </ul>
          <p>Podaci se neće koristiti u marketinške svrhe bez izričitog pristanka korisnika.</p>

          <h2>3. Pohrana i zaštita podataka</h2>
          <p>
            Poduzimamo odgovarajuće tehničke i organizacijske mjere kako bismo zaštitili osobne podatke od neovlaštenog pristupa, gubitka ili zloupotrebe.
          </p>

          <h2>4. Dijeljenje podataka s trećim stranama</h2>
          <p>
            Osobni podaci korisnika neće se prodavati, iznajmljivati niti dijeliti s trećim stranama, osim ako je to zakonski obvezno.
          </p>

          <h2>5. Kolačići (Cookies)</h2>
          <p>
            Web stranica može koristiti kolačiće radi poboljšanja korisničkog iskustva. Kolačići ne sadrže osobne podatke i mogu se u svakom trenutku onemogućiti u postavkama preglednika.
          </p>

          <h2>6. Prava korisnika</h2>
          <p>Korisnici imaju pravo zatražiti:</p>
          <ul>
            <li>pristup svojim osobnim podacima</li>
            <li>ispravak ili brisanje podataka</li>
            <li>ograničenje obrade podataka</li>
          </ul>
          <p>Za ostvarivanje svojih prava korisnici nas mogu kontaktirati putem navedenih kontakt podataka.</p>

          <h2>7. Promjene politike privatnosti</h2>
          <p>
            Zadržavamo pravo izmjene ove Politike privatnosti u bilo kojem trenutku. Sve promjene bit će objavljene na ovoj stranici.
          </p>

          <h2>8. Kontakt</h2>
          <p>
            Za sva pitanja vezana uz ovu Politiku privatnosti možete nas kontaktirati putem e-mail adrese navedene na web stranici.
          </p>
          <p className="privacy-email">
            <a href="mailto:info@slatkobezglutena.com">
              info@slatkobezglutena.com
            </a>
          </p>
        </div>
      </section>
    </div>
  );
}

